import * as types from '../action/actionTypes';
import initialState from './initialState';

export default function HubManagementReducer(state = initialState.HubManagement, action){
    switch(action.type){
        case types.GET_EXTERNALURI_TEMPLATE_DETAILS: 
        return{
            ...state,GetExternalHubUri: action.getResponse
        }
        case types.GET_NETWORKLIST_TEMPLATE_DETAILS:
            return{
                ...state, GetNetworkList: action.getResponse,
            }
            case types.GET_CERTIFICATELIST_TEMPLATE_DETAILS:
            return{
                ...state, certificateList: action.getResponse,
            }
            case types.GET_NETWORKDETAILLIST_TEMPLATE_DETAILS:
            return{
                ...state, GetNetworkDetailList: action.getResponse,
            }
        default : return state;
    }
}